export enum EventSectionBackgroundSize {
  FULL = 'FULL',
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  FULL_OVERFLOW = 'FULL_OVERFLOW',
}
